module.exports = __webpack_public_path__ + "media/swainsons-thrush-2.617ab5a0.mp3";